import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/apps";

import RaisedButton from "material-ui/RaisedButton";

import Fab from "@material-ui/core/Fab";
import IconEdit from "material-ui/svg-icons/editor/mode-edit";
import IconLibrary from "material-ui/svg-icons/av/library-books";
import IconAward from "material-ui/svg-icons/action/redeem";
import IconPrint from "material-ui/svg-icons/action/print";
import IconEmail from "material-ui/svg-icons/communication/email";

import AppFrame from "./Appframe/AppFrame";
import Subtitle from "../components/common/Subtitle";
import InfoText from "../components/common/InfoText";
import Title from "../components/common/Title";
import Padding from "../components/common/Padding";
import NoteArea from "../components/common/NoteArea";
import UserInstructionsText from "./playbook/UserInstructionsText";
import InviteUser from "../components/common/InviteUser";
import WrapDialogue from "../components/common/WrapDialogue";
import TitledImage from "../components/common/TitledImage";
import { Dialog, DialogActions, DialogContent } from "@material-ui/core";

import layout from "../styles/layout";
import help from "../documents/help";
import { Mixpanel } from "../mixpanel";

const style = {
  editButton: {
    position: "absolute",
    top: 20,
    right: 20,
  },
};

class AppDetailViewer extends Component {
  constructor(props) {
    super(props);

    let appId = props.match.params.appId;
    let appInfo = this.props.apps.appInfos[appId];
    this.state = {
      showSaved: false,
      appId,
      appInfo,
      dialogue: {
        title: "Info",
        content: "message",
      },
      width: 0,
      height: 0,
      showUserInstructions: false,
      sentOk: false,
    };

    this.renderProfile = this.renderProfile.bind(this);
    this.editInfo = this.editInfo.bind(this);
    this.editContent = this.editContent.bind(this);
    this.inviteSent = this.inviteSent.bind(this);
    this.goToChannelList = this.goToChannelList.bind(this);
    this.goToCSATReport = this.goToCSATReport.bind(this);
    this.goToNPSReport = this.goToNPSReport.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillReceiveProps(nextProps) {
    let appInfo = nextProps.apps.appInfos[this.state.appId];
    if (appInfo) {
      Mixpanel.track("View channel", {
        "User ID": this.props.userId,
        "Channel Name": appInfo.appName,
        "Channel ID": appInfo.appId,
        "Channel Type": appInfo.appType,
        isProvider: true,
        Platform: "Web",
      });

      this.setState({
        appInfo,
      });
    }
  }

  editInfo() {
    let link = `/update-app-info/${this.state.appId}`;
    this.props.history.push(link);
  }

  editContent() {
    let link = `/libraries/${this.state.appId}`;
    this.props.history.push(link);
    Mixpanel.track("View channel library", {
      "Channel Name": this.state.appInfo.appName,
      "Channel ID": this.state.appInfo.appId,
      "App Type": this.state.appInfo.appType,
    });
  }

  editRewards() {
    let link = `/manage-custom-rewards/${this.state.appId}`;
    this.props.history.push(link);
    Mixpanel.track("View Channel Rewards", {
      "Channel Name": this.state.appInfo.appName,
      "Channel ID": this.state.appInfo.appId,
      "App Type": this.state.appInfo.appType,
    });
  }

  saveChanges() {
    this.props.updateAppInfo(
      this.props.userId,
      this.state.appId,
      this.state.appInfo
    );
    Mixpanel.track("Update channel detail", {
      "Channel Name": this.state.appInfo.appName,
      "Channel ID": this.state.appId,
      "App Type": this.state.appInfo.appType,
    });
    this.setState({ showSaved: true });
    setTimeout(() => {
      this.setState({ showSaved: false });
    }, 2000);
  }

  inviteSent(inviteUserData) {
    this.setState({ sentOk: true });
    setTimeout(() => this.setState({ sentOk: false }), 3000);
    this.refs.emailUserInstDialogue.close();
    Mixpanel.track("Invite user channel dashboard", {
      "Channel Name": this.state.appInfo.appName,
      "Channel ID": this.state.appInfo.appId,
      "Channel Type": this.state.appInfo.appType,
      "First Name": inviteUserData.firstName,
      "Last Name": inviteUserData.lastName,
      Platform: "Web",
    });
  }

  emailUserInstDialogue() {
    return (
      <WrapDialogue
        ref="emailUserInstDialogue"
        title="Send Invitation"
        content={
          <div>
            <div>
              {"We will send them an email invitation to join your Channel:"}
            </div>
            <InviteUser
              userId={this.props.userId}
              appId={this.state.appId}
              sender={this.props.user.email}
              onComplete={() => this.inviteSent()}
              onClose={() => this.refs.emailUserInstDialogue.close()}
            />
          </div>
        }
      />
    );
  }

  renderProfile() {
    return (
      <div
        style={{
          ...layout.common.paperContainer,
          ...{
            display: "flex",
            flexDirection: "row",
            felx: 1,
            position: "relative",
            justifyContent: "space-between",
            alignContent: "center",
          },
        }}
      >
        {this.state.appInfo && (
          <div style={{ flex: 1 }}>
            <Subtitle text={this.state.appInfo.appName} />
            <p>Provider: {this.state.appInfo.author}</p>
            {this.state.appInfo.appDesc && (
              <p>Description: {this.state.appInfo.appDesc}</p>
            )}
            {this.state.appInfo.websiteUrl && (
              <p>
                Website:{" "}
                <a href={this.state.appInfo.websiteUrl} target="_blank">
                  {this.state.appInfo.websiteUrl}
                </a>
              </p>
            )}
            <div style={{ display: "flex", flexFlow: "row", flexWrap: "wrap" }}>
              {this.state.appInfo.coverUrl && (
                <TitledImage
                  title="Custom Cover"
                  src={this.state.appInfo.coverUrl}
                  height={300}
                />
              )}
            </div>
          </div>
        )}
        <Fab
          style={style.editButton}
          onClick={() => this.editInfo()}
          color={!this.props.whiteLabelSettings.isWhiteLabel ? "primary" : "na"}
          mini={true}
        >
          <IconEdit />
        </Fab>
      </div>
    );
  }

  goToChannelList() {
    let link = `/view-channels`;
    this.props.history.push(link);
  }

  goToAppSettings() {
    let link = `/app-settings/${this.state.appId}`;
    this.props.history.push(link);
  }

  goToCSATReport() {
    let link = `/reporting/csat-report/${this.state.appId}`;
    this.props.history.push(link);
  }

  goToComplianceReport() {
    let link = `/reporting/patient-report/`;
    this.props.history.push(link);
  }

  goToPatientActivityLog() {
    let link = "/reports/channel/patient-client-activity-log";
    this.props.history.push(link);
  }

  goToNPSReport() {
    let link = `/reporting/nps-report/${this.state.appId}`;
    this.props.history.push(link);
  }

  render() {
    return (
      <AppFrame
        auth={this.props.auth}
        header="Channel Dashboard"
        optionsType="appDetail"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <Title goBack={this.goToChannelList} />
        <div style={layout.common.page}>
          <Padding height={20} />
          <div style={layout.common.detailsContainer}>
            {this.renderProfile()}
            <NoteArea>
              <h1>{"Channel Customizations"}</h1>
              <p>
                {"Adjust settings for onboarding, marketing, RTM and more."}
              </p>
              <RaisedButton
                primary={!this.props.whiteLabelSettings.isWhiteLabel}
                label="View Customization Options for your channel"
                icon={<IconLibrary />}
                onClick={() => this.goToAppSettings()}
              />
            </NoteArea>
            <NoteArea>
              <p>
                {"To Add General Instructions for All of Your Patients/Clients"}
              </p>
              <RaisedButton
                primary={!this.props.whiteLabelSettings.isWhiteLabel}
                label="My Library"
                icon={<IconLibrary />}
                onClick={() => this.editContent()}
              />
              <br />
              <p>{"Add Custom Rewards For Your Practice"}</p>
              <RaisedButton
                primary={!this.props.whiteLabelSettings.isWhiteLabel}
                label="Your Custom Rewards"
                icon={<IconAward />}
                onClick={() => this.editRewards()}
              />
              <br />
            </NoteArea>
            {this.emailUserInstDialogue()}
          </div>
          {this.state.showUserInstructions && (
            <UserInstructionsText
              id="divUserInstructions"
              appId={this.state.appId}
              appInfo={this.state.appInfo}
            />
          )}
        </div>
        <Dialog modal={false} open={this.state.sentOk}>
          Invitation Sent Successfully
        </Dialog>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, whiteLabelSettings }) {
  return {
    userId: user.userId,
    user,
    apps,
    whiteLabelSettings,
  };
}
//updateAppInfo

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AppDetailViewer);



// WEBPACK FOOTER //
// ./src/layout/AppDetailViewer.js